import Api from "./Api";

class ConfigApi extends Api {
  get() {
    const url = this.prepareUrl("/disclosurecode/private/config/");
    return this.requestGet(url, {}, "object");
  }
}

export default new ConfigApi();
